<template>
	<div v-show="bodyIsShow">
		<section class="marB1">
            <div class="topcar clearfix">
                <div class="imgcar">
                    <img src="//static.tuanche.com/wap2017/dist/img/common/top-car.png">
                </div>
                <div class="sizebox clearfix">
                    <span class="blacksize">真不巧!</span>
                    <span class="blacksize">本届惠民团车节已结束</span>
                    <span class="graysize">下届团车节正在拍马赶来,<a href="/"><em class="backfirst">&nbsp;返回首页&gt;&gt;</em></a></span>
                </div>
            </div>
        </section>
 		<section>
            <div class="whyselect clearfix">
                <div class="line1"></div>
                为什么选择团车
                <div class="line2"></div>
        
                    <div class="pldge-wrap clearfix">
                        <div class="promise1 promise  bigline btnline">
                            <em class="icon01"></em>
                            <div class="rightbox">
                                <div class="title">积淀深厚</div>
                                <div class="center">成立于2010年,2017</div>
                                <div class="size-btn">全年为用户节省20亿元</div>
                            </div>
                        </div>
                        <div class="line"></div>
                        <div class="promise2 promise btnline">
                         <em class="icon02"></em>
                         <div class="rightbox">
                             <div class="title">覆盖全面</div>
                             <div class="center">百城覆盖,超过百余</div>
                             <div class="size-btn">品牌曾参展团车节</div>
                         </div>

                        </div>
                        <div class="promise3 promise bigline">
                          <em class="icon03"></em>
                          <div class="rightbox">
                            <div class="title">车源优质</div>
                            <div class="center">正规厂家4s店合作</div>
                            <div class="size-btn">提供优质车源</div>
                          </div>
                        </div>
                        <div class="promise4 promise">
                         <em class="icon04"></em>
                          <div class="rightbox">
                            <div class="title">价格保障</div>
                            <div class="center">全国范围询价</div>
                            <div class="size-btn">确保低价</div>
                          </div>
                        </div>
                    </div>
            
            </div>
        </section>

		<footerComponent></footerComponent>
	</div>
</template>

<style scoped lang="less">
	@import "../../assets/less/common.less";

	
</style>
<script>
import msg from "@/data/dataSuc.js";
export default {
	name: 'over',
	data:function() {
		return {
			bodyIsShow:false
		}
	},
	beforeCreate:function(){
		getCommonJsIns.initCSS({
			cssURL:"/css/carfestival/end.css"
		});
	},
	mounted:function(){
		var self = this;
		document.title="报名成功页"
		getCommonJsIns.initJS({
			jsURL:"/js/app/carfestival/end.js",
			callback:function(){
				self.webReady()
			}
		});
	},
	methods:{
		webReady:function(){
      this.bodyIsShow = true;
		}
		
	}
}
</script>


// WEBPACK FOOTER //
// src/views/carfestival/over.vue